
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movies/[id]/[slug]",
      function () {
        return require("private-next-pages/movies/[id]/[slug].tsx");
      }
    ]);
  